import { createGlobalStyle } from "styled-components";

const MyGlobalStyles = createGlobalStyle`
    body { 
        background: #FFFFFF;
        font-family: 'Noto Sans', sans-serif;
        font-weight: 500;
    }
`;

export default MyGlobalStyles;
